export default __webpack_public_path__ + "195f1587bf92a96c5fb48b0b4061772a.svg";